<fcom-icon-button
  data-testid="mobile-navigation-toggle-button"
  [theme]="isOpen ? IconButtonTheme.TERTIARY_GHOST_REVERSED : IconButtonTheme.TERTIARY_GHOST"
  [icon]="{
    name: isOpen ? SvgLibraryIcon.CHEVRON_LEFT : SvgLibraryIcon.MENU_LIST,
  }"
  [aria]="{
    label: (isOpen ? 'menu.close' : 'menu.open') | finLocalization,
  }"
  (clickBtn)="toggleMenu()"
/>
